import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import API from '../../utils/api';
import toast from 'react-hot-toast';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginUser } = useAuth();

  const hasRun = React.useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      toast.error('OAuth login failed. Please try again.', { id: 'oauth-error' });
      navigate('/login');
      return;
    }

    if (!token) {
      toast.error('No token received. Please try again.', { id: 'oauth-token-error' });
      navigate('/login');
      return;
    }

    const handleOAuth = async () => {
      try {
        // Save token
        localStorage.setItem('wi_token', token);

        // Get user profile
        const res = await API.get('/user/profile', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (res.data.success) {
          const user = res.data.data;

          // Save user
          localStorage.setItem('wi_user', JSON.stringify(user));

          // Update auth context
          loginUser(token, user);

          toast.dismiss();
          toast.success(`Welcome, ${user.name}! 🎉`, { id: 'welcome-toast' });

          // Redirect
          if (user.role === 'admin') {
            navigate('/admin', { replace: true });
          } else if (user.role === 'mentor') {
            navigate('/mentor/dashboard', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
        } else {
          throw new Error('Failed to get user profile');
        }
      } catch (err) {
        console.error('OAuth callback error:', err);
        toast.error('Login failed. Please try again.');
        localStorage.removeItem('wi_token');
        localStorage.removeItem('wi_user');
        navigate('/login', { replace: true });
      }
    };

    handleOAuth();
  }, [navigate, searchParams, loginUser]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0d1b2e, #1B2A4A)',
        flexDirection: 'column',
        gap: '1rem'
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          border: '3px solid #18b45b',
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }}
      />
      <p
        style={{
          color: 'rgba(255,255,255,0.7)',
          fontFamily: 'DM Sans, sans-serif'
        }}
      >
        Completing login...
      </p>

      <style>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
      `}</style>
    </div>
  );
};

export default OAuthCallback;